import type { EngineId } from "../report/contracts";
import { guardVietnameseDisplayText } from "./text-guard";

export const LEGAL_DISCLAIMER_VI =
  "Không dùng kết quả này thay thế tư vấn y tế, pháp lý, tài chính hoặc quyết định an toàn.";

export function isLegalDisclaimer(warningVi: string): boolean {
  return warningVi === LEGAL_DISCLAIMER_VI;
}

const knownBlockedReasonVi: Readonly<Partial<Record<EngineId, string>>> =
  Object.freeze({
    feng_shui:
      "Phong Thủy cần thông tin nhà/không gian và hướng nhà rõ ràng; chưa đủ dữ kiện để tính.",
  });

function genericBlockedReasonVi(engine: EngineId): string {
  return `Phương pháp ${engine} chưa đủ căn cứ để tính toán; đang chờ quy tắc và bộ mẫu chuẩn được chuyên gia ký duyệt.`;
}

function genericFailedReasonVi(): string {
  return "Có lỗi kỹ thuật khi tính toán; đã ghi nhận để kiểm tra, kết quả chưa được hiển thị.";
}

export function translateBlockedReason(
  engine: EngineId,
  rawReasonVi: string,
): string {
  const guard = guardVietnameseDisplayText(
    rawReasonVi,
    knownBlockedReasonVi[engine] ?? genericBlockedReasonVi(engine),
  );
  return guard.textVi;
}

export function translateFailedReason(): string {
  return genericFailedReasonVi();
}
